import AddNewInline from "./modules/add-new-inline";
import { initAcServices } from "AC/helpers/admin-columns";
var AcServices = initAcServices();
document.addEventListener('DOMContentLoaded', function () {
    AcServices.registerService('AddNewInline', new AddNewInline());
});
